import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { config } from './config';

export const supportedLngs = config.AVAILABLE_LOCALES;
const { ASSET_PREFIX } = config;

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: config.DEFAULT_LOCALE,
    supportedLngs: config.AVAILABLE_LOCALES,
    detection: {
      order: ['path', 'localStorage', 'cookie','sessionStorage', 'htmlTag','subdomain'],
      caches: ['localStorage', 'cookie'],
      lookupFromPathIndex: 0,
    },
    interpolation: {
      escapeValue: false,
    },
    defaultNS: 'common',
    react: {
      useSuspense: true,
    },
    backend: {
      loadPath: `${ASSET_PREFIX}/locales/{{lng}}/{{ns}}.json`
    },
  });